import axios from 'axios';
import { api_labelflow,api_labelflow_training } from "../../../../config.jsx";

export const getModelsAPI = (params) =>
    axios.get(`${api_labelflow}/model_management/get_models`, {
        params: params
    });

export const saveModelAPI = (params) =>
    axios.post(`${api_labelflow}/model_management/save_model`, params, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

export const editModelAPI = (params) =>
    axios.put(`${api_labelflow}/model_management/update_one_model`, params);

export const deleteModelAPI = (params) =>
    axios.delete(`${api_labelflow}/model_management/delete_model`, params);
export const deleteModelVersionAPI = (params) =>
    axios.delete(`${api_labelflow}/model_management/delete_model_version`, params);

// NOTE: no `getOneModelAPI` here, deliberately — see the same note in
// projectManagement/api/projectManagementAPI.js. It POSTed to
// `/report_management/send_summary_report`, which no backend declares.

export const getProjectsDDAPI = (params) =>
    axios.get(`${api_labelflow}/model_management/get_projects_dd`, {
        params: params
    });

export const getPublicModelsAPI = (params) =>
    axios.get(`${api_labelflow}/model_management/get_public_models`, {
        params: params || {},
        timeout: 15000,
    });

export const getTrainingProgressAPI = (params) =>
    axios.get(`${api_labelflow_training}/streaming_management/training-progress`, {
        params,
    });

export const getTrainingLogsAPI = (params) =>
    axios.get(`${api_labelflow_training}/streaming_management/training-logs`, {
        params,
    });



export const handleDownloadImagesAPI = async (params) => {
  try {
    const response = await axios.post(
      `${api_labelflow_training}/export_management/download_images`,
      new URLSearchParams(params), // Send params as form data
      {
        responseType: 'blob', // Expect binary response
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error downloading classification data:', error);
    throw error;
  }
};

export const downloadTrainedModelAPI = (params) =>
  axios.get(`${api_labelflow_training}/training_management/download_model`, {
    params,
    responseType: 'blob',
  });

// ── Deployment model pack (model bridge, phase L0) ──────────────────────────
// NOTE: no path in this file carries a trailing slash, deliberately — and as of
// 2026-09-13 that is true of every API path in the frontend. FastAPI
// 307-redirects a slash mismatch and builds Location from the Host header, which
// behind this deployment's nginx points at the API host — cross-origin AND mixed
// content, so the browser refuses to follow it and the call silently returns
// nothing. The nginx `proxy_redirect` rewrites it back, but the cheapest way not
// to depend on that directive is not to generate the redirect at all. See
// 3_infra/nginx/README.md.

// Claims a build and returns immediately — the OpenVINO export takes 20-60s, which
// is past nginx's proxy_read_timeout. Poll getModelPackAPI for the outcome.
export const publishModelPackAPI = (params) =>
    axios.post(
        `${api_labelflow_training}/model_pack/publish`,
        new URLSearchParams(params),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    );

export const getModelPackAPI = (params) =>
    axios.get(`${api_labelflow_training}/model_pack/info`, { params });

export const getModelPackDownloadUrlAPI = (params) =>
    axios.get(`${api_labelflow_training}/model_pack/download_url`, { params });
